/**
 * Languages offered by the app UI (login + settings menu) and the storage keys that hold the choice.
 * `LocalStorageService` stores values JSON-quoted (e.g. `"pt"` with the quotes) under these keys.
 */
export type AppLangCode = 'pt' | 'en' | 'es';

export interface AppLang {
  code: AppLangCode;
  flag: string;
}

export const DEFAULT_FLAG = '/assets/images/flags/br.svg';

export const APP_LANGUAGES: readonly AppLang[] = [
  { code: 'pt', flag: '/assets/images/flags/br.svg' },
  { code: 'en', flag: '/assets/images/flags/us.svg' },
  { code: 'es', flag: '/assets/images/flags/es.svg' },
];

export const DEFAULT_LANG: AppLang = APP_LANGUAGES[0];

export const GLOBAL_LANG_KEY = 'appLang';
export const userLangKey = (userId: string): string => `appLang_${userId}`;

export function normalizeLang(input?: string | null): AppLangCode {
  const raw = (input ?? '').toLowerCase();
  if (raw.startsWith('pt')) return 'pt';
  if (raw.startsWith('en')) return 'en';
  if (raw.startsWith('es')) return 'es';
  return 'pt';
}

export function findLang(code: string | null | undefined): AppLang {
  return APP_LANGUAGES.find((l) => l.code === code) ?? DEFAULT_LANG;
}
